/* Le vocabulaire des dossiers : les états des réclamations, et le rappel des
   étapes du packaging sous la forme que les listes attendent.
   Un seul endroit : les écrans, les filtres et les agrégats les partagent. */

import { ABANDONNE, CLOS, ETAPES as ETAPES_PK } from "./packaging";

export interface DefEtat {
  cle: string;
  nom: string;
  ton: string;
}

/* Les étapes du packaging vivent dans leur propre module, avec leurs portes et
   leur stock. On les réexporte ici sous la forme attendue par les écrans de
   liste, pour qu'il n'y ait qu'une seule vérité sur leurs noms et leurs
   teintes. */
export const ETAPES_PACKAGING: readonly DefEtat[] =
  [...ETAPES_PK, ABANDONNE].map((e) => ({ cle: e.cle, nom: e.nom, ton: e.ton }));

/** Un dossier reçu ou abandonné ne compte plus dans les dossiers ouverts. */
export const PACKAGING_CLOS = [...CLOS];

export const GRAVITES: readonly DefEtat[] = [
  { cle: "mineure", nom: "Mineure", ton: "" },
  { cle: "majeure", nom: "Majeure", ton: "warn" },
  { cle: "critique", nom: "Critique", ton: "crit" },
];

export const STATUTS_RECLAMATION: readonly DefEtat[] = [
  { cle: "ouverte", nom: "Ouverte", ton: "warn" },
  { cle: "en_cours", nom: "En cours", ton: "accent" },
  { cle: "resolue", nom: "Résolue", ton: "ok" },
  { cle: "classee", nom: "Classée", ton: "" },
];

export const RECLAMATION_CLOSE = ["resolue", "classee"];

/** Retrouve un état par sa clé, sans jamais rendre « indéfini » à l'écran. */
export function etatDe(liste: readonly DefEtat[], cle: string | null | undefined): DefEtat {
  const c = cle ?? "";
  return liste.find((e) => e.cle === c) ?? { cle: c, nom: c || "—", ton: "" };
}
